var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Services;
        (function (Services) {
            //"use strict";
            var BaseService = /** @class */ (function () {
                function BaseService() {
                }
                return BaseService;
            }());
            Services.BaseService = BaseService;
        })(Services = Core.Services || (Core.Services = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=baseservice.js.map